import { Dispatch, ReactNode } from 'react';
import { Brand } from '@stax-core/types-omni';

export interface BrandContextProps {
  children: ReactNode;
  initialState?: BrandState;
}

export interface BrandMCC {
  id: string;
  name: string;
  displayName: string;
  position: number;
}

export interface BaseBrand {
  brand: Brand | null;
  brandName: string | null;
  mcc: BrandMCC[] | null;
}

export interface BrandState extends BaseBrand {
  effect: { type: BrandEffectType; payload?: BaseBrand } | null;
}

export enum BrandActionType {
  REMOVE_BRAND = 'REMOVE_BRAND',
  UPDATE_BRAND = 'UPDATE_BRAND',
}

export enum BrandEffectType {
  REMOVE_BRAND = 'REMOVE_BRAND',
  UPDATE_BRAND = 'UPDATE_BRAND',
}

export type BrandAction = { type: BrandActionType; payload?: BaseBrand };

export interface BrandContext {
  state: BrandState;
  dispatch: Dispatch<BrandAction>;
}
